/* Uchi · Press kit page: copy buttons and the mobile chapter accordion. */
  (() => {
    document.querySelectorAll('[data-press]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    // Copy: boilerplate and short version as plain paragraphs, the fact sheet as "Label: value" lines.
    const textOf = (key) => {
      if (key === 'facts') {
        return [...root.querySelectorAll('[data-copy-src="facts"] [data-k]')].map((r) => r.dataset.k + ': ' + r.dataset.v).join('\n');
      }
      const el = root.querySelector('[data-copy-src="' + key + '"]');
      if (!el) return '';
      return el.innerText.replace(/\n{3,}/g, '\n\n').trim();
    };
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-copy]');
      if (!btn) return;
      const text = textOf(btn.dataset.copy);
      const label = btn.textContent;
      const done = () => {
        btn.textContent = btn.dataset.done || 'Copied';
        btn.classList.add('is-done');
        clearTimeout(btn._t);
        btn._t = setTimeout(() => { btn.textContent = label; btn.classList.remove('is-done'); }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, done);
      else {
        const ta = document.createElement('textarea'); ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (err) {} ta.remove(); done();
      }
    });

    // Story: chapters are always open on desktop; on mobile they fold into an accordion, first one open.
    const chapters = [...root.querySelectorAll('.u3-press__ch')];
    const mq = window.matchMedia('(min-width: 750px)');
    const sync = () => {
      if (mq.matches) chapters.forEach((d) => { d.open = true; });
      else chapters.forEach((d) => { d.open = d.hasAttribute('data-first'); });
    };
    sync();
    mq.addEventListener('change', sync);
    chapters.forEach((d) => d.addEventListener('toggle', () => {
      if (mq.matches || !d.open) return;
      chapters.forEach((o) => { if (o !== d) o.open = false; });
    }));
    // Contents links open the target chapter on mobile.
    root.querySelectorAll('a[href^="#press-"]').forEach((a) => a.addEventListener('click', () => {
      const t = root.querySelector(a.getAttribute('href'));
      if (t && t.tagName === 'DETAILS') t.open = true;
    }));
  });
  })();
